var map = {
	"./afternoon-icon.png": 450,
	"./afternoon-passed-icon.png": 888,
	"./day-icon.png": 451,
	"./day-passed-icon.png": 889,
	"./evening-icon.png": 452,
	"./evening-passed-icon.png": 890,
	"./ios-browser-menu-icon.png": 453,
	"./night-icon.png": 454,
	"./night-passed-icon.png": 891,
	"./off-day-icon.png": 455,
	"./off-day-passed-icon.png": 892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;